'use client';

import { Card, CardContent } from '@/components/ui/card';

import SkeletonCheckbox from './SkeletonCheckbox';

type SkeletonPreferencesCardProps = {
  className?: string;
  itemCount?: number;
};

export default function SkeletonPreferencesCard({
  className,
  itemCount = 1,
}: SkeletonPreferencesCardProps) {
  return (
    <Card className={className}>
      <CardContent className="space-y-4 p-6 min-h-[80px]">
        <SkeletonCheckbox count={itemCount} />
      </CardContent>
    </Card>
  );
}
